import { SubscriptionRoutes } from "..";
import styled from "@emotion/styled";
import * as React from "react";

import { Info } from "@livechat/design-system-icons";
import { Icon } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import { StyledLink } from "components/links/StyledLink";

const SubscriptionInvoicesEmptyState: React.FC<{ hasSubscription: boolean }> = ({ hasSubscription }) => (
  <Container>
    <EmptyState
      icon={<Icon source={Info} size="xxxlarge" />}
      title="Nothing in your Invoices"
      actions={
        !hasSubscription && (
          <StyledLink data-testid="empty-invoices-subscribe-button" kind="secondary" to={SubscriptionRoutes.Plans}>
            Subscribe now
          </StyledLink>
        )
      }
    >
      {hasSubscription
        ? "All your invoices will appear here."
        : "After you subscribe, all your invoices will appear here"}
    </EmptyState>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default SubscriptionInvoicesEmptyState;
